import { FC, Dispatch, SetStateAction } from 'react';
import { WbDrawer } from '@agilelab/plugin-wb-platform';
import { CreateServiceAccountForm } from './CreateServiceAccountForm';

export type CreateServiceAccountDrawerProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onCreated?: () => void;
};

export const CreateServiceAccountDrawer: FC<
  CreateServiceAccountDrawerProps
> = ({ open, setOpen, onCreated }) => {
  return (
    <WbDrawer
      open={open}
      setOpen={setOpen}
      size={50}
      ModalProps={{ keepMounted: false }}
      title="New Service Account"
    >
      <CreateServiceAccountForm onCreated={onCreated} />
    </WbDrawer>
  );
};
